/**
 * CENTRALIZED FINANCE DOCUMENT TYPES
 *
 * Single source of truth for FinanceDocumentType.
 * The type union and runtime array are kept in sync with types.yaml
 * where `used_by_finance: true` marks finance-eligible types.
 *
 * At runtime, validateFinanceTypes() checks that the YAML matches this list.
 */

export const FINANCE_DOCUMENT_TYPES = [
  // Sales
  'invoice',
  'quote',
  'quote_request',
  'billing_submission',
  'credit_note',
  'debit_note',
  'proforma',
  'delivery_note',
  'waybill',
  'sales_order',
  'rma',
  // Purchases
  'purchase_order',
  'grn',
  'supplier_credit',
  'supplier_quote',
  'supplier_invoice',
  'supplier_delivery_note',
  'purchase_requisition',
  'rfq',
  'purchase_return',
  'purchase',
  // Expenses
  'expense',
  // Operations
  'work_order',
  // Warehouse
  'picking_slip',
  'packing_slip',
  'stock_adjustment',
  'transfer_order',
  // Property Finance (real-estate receivables)
  'levy_cycle',
  'meter_reading',
  'utility_recovery',
  'special_levy',
  'scheme_budget',
  'reserve_fund',
  'deposit_holding',
  'trust_transaction',
  'payment_dispute',
  'payment_plan',
  'collection_case',
  'invoice_followup',
  'credit_request',
  'write_off',
] as const;

export type FinanceDocumentType = (typeof FINANCE_DOCUMENT_TYPES)[number];
